import { MakeCall } from './createMakeCall';

const deleteListingVideos = (makeCall: MakeCall) => (listingId: number) =>
  makeCall<undefined>('DELETE', `/api/v2/listing/${listingId}/videos`);

export { deleteListingVideos };
